import { FocusSDK, getClientType } from "@/utils";

export function getStatus() {
  return new Promise((resolve, reject) => {
    const timeout = setTimeout(() => {
      reject(new Error("超时"));
    }, 10000);
    function handle(status: any) {
      clearTimeout(timeout);
      resolve(status);
    }
    FocusSDK.once("xylink:getStatusCb", handle);
    FocusSDK.sendIpcMessage("xylink.getStatus");
  });
}
